module.exports = __webpack_public_path__ + "static/media/logo-uniao-seguradora.ea0772d3.png";